// extracted by mini-css-extract-plugin
module.exports = {"otherlist":"OtherList_otherlist__U4B4e"};